/**
 * @see LastRunInfo
 */
export enum RecoveryStatus {
  Overdue = -2,
  Started = -1,
  Unknown,
  Succeed,
  Warning,
  Failed,
  Running
}
